import { CountryPrefix } from 'Jsx/global';

export const getLabel = (countryPrefix: CountryPrefix): string => {
  switch (countryPrefix) {
    case 'ar':
    case 'pe':
      return 'Número de Documento';
    case 'br':
      return 'Cadastro de Personas Físicas';
    case 'co':
      return 'Documento de Identidad';
    case 'mx':
      return 'Clave Única del Registro de Población';
    default:
      return 'Número de Documento';
  }
};
